import {
  type CanvasElementDataProperties,
  type FieldSortConfig,
} from '@blaze-shared/elements-domain';
import { type DatasetRowGetOptions } from '@blaze-shared/schema-data-access';
import { isDefined } from '@blaze-shared/shared-util';

export function getDatasetRowGetConfig(
  datasetId: string,
  binding: CanvasElementDataProperties | undefined,
  sortConfig: FieldSortConfig | FieldSortConfig[] | undefined,
  additionalProjectColumns: string[] = [],
): DatasetRowGetOptions {
  const config: DatasetRowGetOptions = { datasetId };
  if (binding?.dataSource?.projectColumns) {
    // fetch only used columns (value, label, optionally sort field)
    config.projectColumns = Object.values(binding.bindings ?? {});
    if (additionalProjectColumns.length) {
      config.projectColumns.push(...additionalProjectColumns);
    }
    const sortFields = (Array.isArray(sortConfig) ? sortConfig : [sortConfig])
      .map((sc) => sc?.field)
      .filter(isDefined);
    if (sortFields.length) {
      config.projectColumns.push(...sortFields);
    }
  }
  if (!binding?.dataSource?.projectColumns || !config.projectColumns?.length) {
    // Restrict to 1000 rows for performance -> if the user needs more, they can use a workflow
    config.maxResults = 1000;
  }
  return config;
}
